import { render, staticRenderFns } from "./PainelAgrotec.vue?vue&type=template&id=504548ee"
import script from "./PainelAgrotec.vue?vue&type=script&lang=js"
export * from "./PainelAgrotec.vue?vue&type=script&lang=js"
import style0 from "./PainelAgrotec.vue?vue&type=style&index=0&id=504548ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports